import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import AddProjects from "../../../components/BusinessDevelopmentAndPartnerships/projects/Forms/AddProjects";
import EditProject from "../../../components/BusinessDevelopmentAndPartnerships/projects/Forms/EditProjects";
import ProjectsTable from "../../../components/BusinessDevelopmentAndPartnerships/projects/Tables/ProjectsTable";
import routes from "../../../config/routes/routes";
import projectThunks from "../../../config/thunks/businessDevAndPartnerships/projects/projects.thunks";
import logDetailThunks from "../../../config/thunks/settings/logDetails.thunks";
import { Tabs } from "antd";

const Projects = () => {
  const { projectsSuccess, projects } = useSelector(
    (state) => state.projectsState
  );
  const dispatch = useDispatch();
  /** functions */
  const refreshtable = () => {
    dispatch(projectThunks.getProjects());
    dispatch(projectThunks.projectsMetaData());
  };
  const addProject = (values, projects) =>
    dispatch(projectThunks.addProjects(values, projects));
  const deleteProject = (id, name, projects) =>
    dispatch(projectThunks.deleteProject(id, name, projects));
  const exportRecords = () => {
    dispatch(
      logDetailThunks.addLogDetails({
        created_at: new Date(),
        activity: "Exported Projects Records",
        records: "projects",
      })
    );
  };
  const editProject = (values, projects) =>
    dispatch(projectThunks.editProjects(values, projects));
  //useEfffect
  useEffect(() => {
    document.title = routes.businessDevelopmentAndPartnerships.projects.title;
    if (!projectsSuccess) {
      dispatch(projectThunks.getProjects());
      dispatch(projectThunks.projectsMetaData());
    }
  }, [projectsSuccess, dispatch]);

  console.log({ projectsSuccess })
  return (
    <div className="container-fluid p-2">
      <h5 className="fw-bold">PROJECTS</h5>
      <Tabs
        type="card"
        tabBarStyle={{
          marginBottom: "0",
        }}
        items={[
          {
            label: "ACTIVE PROJECTS",
            key: "activeProjects",
            children: (
              <ProjectsTable
                data={projects.activeProjects}
                handleExportRecords={exportRecords}
                handleRefreshTable={refreshtable}
                handleDelete={deleteProject}
              />
            ),
          },
          {
            label: "COMPLETED PROJECTS",
            key: "completedProjects",
            children: (
              <ProjectsTable
                data={projects.completedProjects}
                handleExportRecords={exportRecords}
                handleRefreshTable={refreshtable}
                handleDelete={deleteProject}
              />
            ),
          }
        ]}
      />
      <AddProjects handleAddRecord={addProject} />
      <EditProject handleEditRecord={editProject} />
    </div>
  );
};

export default Projects;
